import { Realizado } from './realizado';
import { Mes } from './mes';

/** Dados de um trimestre para os KPI's de produtividade */
export class Trimestre {
    trimestre: number;
    meses: Mes[];
    orcamentos: Realizado;
    orcamentosPerdidos: Realizado;
    pedidos: Realizado;

    constructor(props: Partial<Trimestre>) {
        Object.assign(this, props);
        // Meses
        this.constructorMeses(props?.meses ?? []);
        // Orçamentos
        this.orcamentos = new Realizado(props?.orcamentos ?? null);
        // Orçamentos Perdidos
        this.orcamentosPerdidos = new Realizado(props?.orcamentosPerdidos ?? null);
        // Pedidos
        this.pedidos = new Realizado(props?.pedidos ?? null);
    }

    /** Constructor para os meses */
    private constructorMeses(meses: Mes[]) {
        if (meses && Array.isArray(meses)) {
            this.meses = meses.map(mes => new Mes(mes));
        } else {
            this.meses = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Trimestre {
        return new Trimestre(JSON.parse(json));
    }
}
